// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__Ga_FM","buttons":"PendingPaymentAlert_buttons__3nB4u"};